__turbopack_context__.v({
  "toggleButton": "scroll-fab-module__bLwvba__toggleButton",
  "toggleGroupContainer": "scroll-fab-module__bLwvba__toggleGroupContainer",
});
